import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import budgit from "../../../assets/logos/budgit.png";
import civic from "../../../assets/logos/civic.svg";
// import luminate from "../../../assets/logos/luminate.png";
import ford from "../../../assets/logos/ford.png";
import open from "../../../assets/logos/open.png";

const Sponsor = () => {
  return (
    <Box padding={{ xs: "5% 0%", sm: "5% 0%" }} width={"100%"}>
      <Box>
        <Typography
          variant="h3"
          color="#D7A036"
          fontWeight={800}
          paddingBottom={"1%"}
          textAlign={"left"}
        >
          <Typography
            component={"span"}
            color="#831312"
            fontWeight={800}
            variant={"h3"}
          >
            Our {""}
          </Typography>
          Partners
        </Typography>
      </Box>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        flexWrap={"wrap"}
        width={{ xs: "100%", sm: "100%" }}
        padding={{ xs: "5% 0%", sm: "2% 0%" }}
        marginLeft={{ xs: "0%", sm: "0%" }}
        // data-aos={"fade-down"}
      >
        <Box
          component="img"
          height={{ xs: "9vh", sm: "70px" }}
          width={{ xs: "45%", sm: "18%" }}
          marginRight={{ xs: "0%", sm: "2%" }}
          sx={{
            filter: "grayscale(0%)",
            "&:hover": {
              filter: "grayscale(100%)",
            },
          }}
          src={ford}
          alt={"Ford Foundation"}
        />
        <Box
          component="img"
          height={{ xs: "9vh", sm: "70px" }}
          width={{ xs: "45%", sm: "18%" }}
          marginLeft={{ xs: "0%", sm: "2%" }}
          sx={{
            filter: "grayscale(0%)",
            "&:hover": {
              filter: "grayscale(100%)",
            },
          }}
          src={open}
          alt={"Open Society Foundations"}
        />
        {/* <Box
          component="img"
          height={{ xs: "9vh", sm: "14vh" }}
          width={{ xs: "45%", sm: "18%" }}
          marginLeft={{ xs: "0%", sm: "2%" }}
          sx={{
            filter: "grayscale(0%)",
            "&:hover": {
              filter: "grayscale(100%)",
            },
          }}
          src={luminate}
          alt={"Luminate"}
        /> */}
        <Box
          component="img"
          height={{ xs: "7vh", sm: "85px" }}
          width={{ xs: "42%", sm: "18%" }}
          marginLeft={{ xs: "0%", sm: "0%" }}
          sx={{
            filter: "grayscale(0%)",
            "&:hover": {
              filter: "grayscale(100%)",
            },
          }}
          src={budgit}
          alt={"budgit_logo"}
        />
        <Box
          component="img"
          height={{ xs: "4vh", sm: "13vh" }}
          width={{ xs: "45%", sm: "21%" }}
          marginTop={{ xs: "8%", sm: "0%" }}
          marginLeft={{ xs: "0%", sm: "0%" }}
          sx={{
            filter: "grayscale(0%)",
            "&:hover": {
              filter: "grayscale(100%)",
            },
          }}
          src={civic}
          alt={"civicHive_logo"}
        />
      </Box>
    </Box>
  );
};

export default Sponsor;
